import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from '../../constant/Utils';
import Header from '../common/Header';
import Footer from '../common/Footer';

import { postSearch, CMS_BASE_URL } from '../../redux/action';

import './home.css'; 
import '../common/common.css'; 

import searchBanner from '../../images/searchBanner.png';
import videoBtn from '../../images/videoBtn.png';

class SearchResult extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	items: [
	    	],
			title: ""
	    };
    }

  componentDidMount() {

		const splits = window.location.href.split('/');

		postSearch({ "word": decodeURI(splits[splits.length - 1]) }).then(res => {
			console.log(res.data);
					this.setState({ 
						title: decodeURI(splits[splits.length - 1]),
						items: res.data
					})
				}, this)

  }

	componentWillMount() {
		
		let token = window.localStorage.getItem("token");
		if (!token) {
			window.location.href = "/login";
		}

	}


	render() {

		return(
			<div className="geContainer">
				<Header urlKey={this.props.urlKey} />
				<div className="mainContainer">
					<img className="banner" src={searchBanner} />
					<div className="sectionContainer">
						<div className="headline containerMaxWidth">
							<h2>Search "{ this.state.title }"</h2>
						</div>
						<div className="bodyContent containerMaxWidth">
							{
								(this.state.items || []).map(pitem => {
									return (
										<div>
											<div className="searchResultSeparator">
												<h3>{ pitem.title }</h3>
											</div>
											<div className="searchContainer">
												{
													(pitem.href == "") ? 
													(
														pitem.items.map(item => {
															return (
																<a href={item.link} className="postItem">
																	<div>
																		<div>
																			<div className="postTitle" dangerouslySetInnerHTML={{ __html: item.section1_title }}></div>
																		</div>
																	</div>
																</a>
															)
														})
													) : 
													(
														pitem.items.map(item => {
															return (
																<a href={"/"+pitem.href+"/"+item.id} className="postItem">
																	<div>
																		<div className="postThumbBox">
																			<img className="postThumb" src={CMS_BASE_URL + "/storage/" + item.thumbnail} />
																			{
																				(pitem.title === "Past Conference Video") ? <img className="videoBtn" src={videoBtn} /> : ""
																			}
																		</div>
																		<div>
																			<p className="postDate">{item.date.split(" ")[0]}</p>
																			<h3 className="postTitle">{item.title}</h3>
																			<div className="postDesc" dangerouslySetInnerHTML={{ __html: item.desc }} ></div>
																		</div>
																	</div>
																</a>
															)
														})
													)
												}
											</div>
										</div>
									)
								})
							}
						</div>
					</div>
				</div>
				<Footer urlKey={this.props.urlKey} />
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(SearchResult));